export default "__VITE_ASSET__BEOlrpMO__"